<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3376 3.115C12.1363 2.96159 11.8637 2.96159 11.6624 3.115L1.19699 11.0932C0.983379 11.256 0.936151 11.5695 1.09151 11.7934C1.24686 12.0174 1.54598 12.0669 
        1.75959 11.904L4 10.1961V20.5645C4 20.8052 4.19761 21 4.44085 21H9.55435C9.78569 21 9.97573 20.8235 9.99332 20.5986L9.99365 20.5944C9.99455 20.5857 9.9952 20.576 
        9.9952 20.5645V14.9545H14.0048V20.5646C14.0048 20.5759 14.0054 20.5853 14.0063 20.5936L14.0068 20.5983C14.0242 20.8233 14.2142 21.0001 14.4456 21.0001L19.5592 
        21.0001C19.8024 21.0001 20 20.8053 20 20.5646V10.1961L22.2404 11.904C22.454 12.0669 22.7531 12.0174 22.9085 11.7934C23.0639 11.5695 23.0166 11.256 22.803 
        11.0932L12.3376 3.115ZM19.0057 9.43808L12 4.09742L4.99432 9.43808C4.99805 9.45829 5 9.47894 5 9.49994V19.9925H8.99929V17.3756V15.0075L9 14.9676C9.01005 14.402 
        9.47719 13.9469 10.0517 13.9469H13.9483C14.5228 13.9469 14.9899 14.402 15 14.9676L15.0005 14.9971L15 19.9925H17.5589L18.9995 19.9925L19 9.49994C19 9.47894 19.002 
        9.45829 19.0057 9.43808Z"
      fill="white"
    />
  </svg>
</template>
